import { render, staticRenderFns } from "./CredenciamentoModalNovaDemanda.vue?vue&type=template&id=96397322"
import script from "./CredenciamentoModalNovaDemanda.vue?vue&type=script&lang=js"
export * from "./CredenciamentoModalNovaDemanda.vue?vue&type=script&lang=js"
import style0 from "./CredenciamentoModalNovaDemanda.vue?vue&type=style&index=0&id=96397322&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports